import React, { useState, useEffect }  from "react";
import DetailsTab from "./Details.jsx";
import BrandPersonality from "./BrandPersonality.jsx";
import BrandKit from "./BrandKit.jsx";
import Socials from "./Socials.jsx";
import styles from "../../../styles/CompanyManagement/CompanyDetails.module.css";
import axiosInstance from "../../../utils/api";

const CompanyDetails = ({ companyId: propCompanyId }) => {
    const [activeTab, setActiveTab] = useState("details");
    const [companyId, setCompanyId] = useState(propCompanyId);

    useEffect(() => {
      if (propCompanyId) {
        setCompanyId(propCompanyId);
      } else {
        axiosInstance.get(`/api/v1/companies`).then(res => {
          const companies = res.data;
          if (companies && companies.length > 0) {
            setCompanyId(companies[0].id);
          }
        });
      }
    }, [propCompanyId]);

    // Sub-tabs for CompanyDetails
    const subTabs = [
      { id: "details", label: "Details", component: <DetailsTab /> },
      { id: "brand-personality", label: "Brand personality", component: <BrandPersonality companyId={companyId} /> },
      { id: "brand-kit", label: "Brand kit", component: <BrandKit companyId={companyId} /> },
      { id: "socials", label: "Socials", component: <Socials companyId={companyId} /> },
    ];
  
    return (
        <div className="company-management-card">
      <div className={styles.header}>
          <div className={`${styles.companyDetailsTabs} ${"rounded"}`}>
            {subTabs.map((tab) => (
              <button
                key={tab.id}
                className={`${styles.companyDetailsTab}  ${"rounded"} ${activeTab === tab.id ? styles.active : ""}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
  
        <div className="tab-content">
          {subTabs.find((tab) => tab.id === activeTab)?.component}
        </div>
      </div>
    );
  };
export default CompanyDetails;
